import { render, staticRenderFns } from "./BaseScrollBox.vue?vue&type=template&id=6309a89e&scoped=true"
import script from "./BaseScrollBox.vue?vue&type=script&lang=js"
export * from "./BaseScrollBox.vue?vue&type=script&lang=js"
import style0 from "./BaseScrollBox.vue?vue&type=style&index=0&id=6309a89e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309a89e",
  null
  
)

export default component.exports